// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2xT3d","savePackageButton":"ClientWallet_savePackageButton__1B0Mh"};